export default {
      id: "telegram-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "sprite.svg#telegram",
      toString: function () {
        return this.url;
      }
    }